export default "__VITE_ASSET__DuXub0IF__"